<template>
    <div class="splash-container">
        <div class="top-logo">
            <img src="@/assets/general/frontline-title.png">
        </div>
        <div class="bottom-left-logo">
            <img src="@/assets/general/frontex-logo-color.png">
        </div>

        <div class="splash text-center">
            <router-link to="/login?redirect=%2Fadmin%2Findicators" class="btn btn-frontex">Admin</router-link>
        </div>
    </div>
</template>

<script>
    import * as MutationTypes from '@/store/mutation-types'


    export default {
        name: 'splash-view',
        beforeMount() {
            this.$router.push('/admin');
        },
        mounted() {
            this.$store.commit(MutationTypes.SET_CURRENT_BACKGROUND, 'login');
        }
    }
</script>

<style scoped lang="scss">
    .splash {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .top-logo, .bottom-left-logo {
        position: absolute;

        img {
            max-width: 100%;
            max-height: 100%;
        }
    }

    .top-logo {
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
    }

    .bottom-left-logo {
        bottom: 5px;
        left: 5px;
    }
</style>